import Vue from 'vue';
import {
    del,
    get,
    set,
} from '@/lib/service/storage';
import { Module } from 'vuex';
import { RootState } from '@/types/store';
import { decodeJwtPayload } from '@/lib/script/crypto';

export interface AuthState {
    /** jwt */
    jwt: string | null;
    /** 解析后jwt */
    parsedJwt: any | null;
    /** 是否已经登录 */
    hasLogin: boolean;
    /** 当前是否正在请求登录 */
    requestLogin: boolean;
}

const m: Module<AuthState, RootState> = {
    namespaced: true,
    state: () => ({
        jwt: null,
        parsedJwt: null,
        hasLogin: false,
        requestLogin: false,
    }),
    mutations: {
        /**
         * 记录jwt
         */
        setJwt(state, jwt) {
            state.jwt = jwt;
            state.parsedJwt = decodeJwtPayload(jwt);
            Vue.axios.defaults.headers.common.Authorization = 'Bearer ' + jwt;
            document.cookie = `t=${jwt};expires=${new Date(state.parsedJwt.exp * 1000)}`;
            set('jwt', jwt);
        },
        /**
         * 设置是否已经登录
         *
         * @param {} hasLogin
         */
        setLogin(state, hasLogin) {
            state.hasLogin = hasLogin;
        },
        /**
         * 标记当前是否正在请求login
         *
         * @param {} request
         */
        setRequestLogin(state, request) {
            state.requestLogin = request;
        },
    },
    actions: {
        /**
         * 登录
         *
         * @param {} 所有需要发送的参数
         *
         * @return {} rdata
         */
        async login({ state, commit }, params) {
            if (state.hasLogin || (params && params.state && params.state.indexOf('wechat') < 0)) {
                // 模拟rdata
                return {
                    status: 0,
                };
            }
            if (state.requestLogin) {
                return {
                    status: 3,
                };
            }
            commit('setRequestLogin', true);
            console.log('target login_wechat_params', params);
            const response = await Vue.axios.post('/api/v1/auth/login_wechat', {
                code: params.code,
            });
            const rdata = response.data;
            const cookie = document.cookie
            console.log('target 验证码cookie', cookie);
            if(response.request.cookie || cookie) {
                set('bindmobile_jwt', response.request.cookie || cookie)
            }
            console.log('target login_wechat_response_data', response);
            if (rdata.status === 0) {
                commit('setLogin', true);
                const jwt = rdata.data;
                if (jwt) {
                    commit('setJwt', jwt);
                    set('jwt', jwt);
                }
            }
            commit('setRequestLogin', false);
            return rdata;
        },
        /**
         * 发送验证码
         */
        async sendLoginSms({ state, commit }, { areaCode, phone }) {
            const response = await Vue.axios.post('/api/v1/auth/send_login_sms', {
                area_code: areaCode,
                phone,
            });
            return response.data;
        },
        /**
         * 检查验证码是否正确
         * @param areaCode
         */
        async checkLoginSms({ state, commit }, { areaCode, phone, code, deviceId, type }) {
            const cookie = get('bindmobile_jwt');
            console.log('target 绑定手机号', cookie);
            const response = await Vue.axios.post('/api/v1/auth/check_login_sms', {
                area_code: areaCode,
                phone,
                code,
                device_id: deviceId,
                type,
            }, {
                headers: {
                    Cookie: cookie,
                },
            });
            del('bindmobile_jwt');
            return response.data;
        },
    },
};

export default m;
